import axios from 'axios';
import { useQuery } from 'react-query';
import { TCourse } from 'types';
import { normalizeJSONAPIResponse } from 'utils/modelUtils';

export const useLibraryCourses = (partnerId: string, page = 1, pageSize = 12, query = '', sort = 'name') => {
  return useQuery<{ courses: TCourse[]; totalPages: number; totalCount: number }>(
    ['libraryCourses', partnerId, page, pageSize, query, sort],
    async () => {
      if (!partnerId) {
        return { courses: [], totalPages: 0, totalCount: 0 };
      }

      try {
        const response = await axios.get(
          `/api/v3/courses?filter[in_library]=true&filter[partner_id]=${partnerId}&include=partner,partner.image&page[number]=${page}&page[size]=${pageSize}&query=${query}&sort=${sort}&tab=default`
        );
        const courses = normalizeJSONAPIResponse(response.data);

        return {
          courses,
          totalPages: response.data.meta?.['total-pages'] || 1,
          totalCount: response.data.meta?.['total-count'] || courses.length,
        };
      } catch (error) {
        console.error('Error fetching courses:', error);
        return { courses: [], totalPages: 0, totalCount: 0 };
      }
    },
    {
      enabled: !!partnerId,
      retry: 2,
    }
  );
};